import { SVGProps } from 'react';

const SendScaleSmallAppearanceOutlined = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M8.00002 8.99972V12.6664M8.19436 12.7228L12.8442 14.2794C13.2094 14.4017 13.3921 14.4629 13.5046 14.419C13.6022 14.3809 13.6763 14.299 13.7045 14.1981C13.7369 14.0818 13.6579 13.9061 13.4998 13.5548L8.48638 2.41385C8.33208 2.07096 8.25494 1.89952 8.14776 1.84653C8.05465 1.8005 7.9454 1.80049 7.85229 1.84653C7.74511 1.89952 7.66796 2.07096 7.51367 2.41385L2.4985 13.5587C2.3409 13.9089 2.2621 14.0841 2.29443 14.2002C2.3225 14.3011 2.39636 14.383 2.49385 14.4212C2.60612 14.4652 2.78837 14.4047 3.15287 14.2838L7.85704 12.7224C7.91965 12.7016 7.95095 12.6912 7.98296 12.6871C8.01137 12.6835 8.04013 12.6835 8.06853 12.6872C8.10053 12.6914 8.13181 12.7019 8.19436 12.7228Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SendScaleSmallAppearanceOutlined;
